import { render } from "./Index-statisticalReports.vue?vue&type=template&id=4eab6017"
import script from "./Index-statisticalReports.vue?vue&type=script&lang=js"
export * from "./Index-statisticalReports.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__